import { useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { Avatar, Badge } from "antd";
import { FaShoppingCart } from "react-icons/fa";
import Search from "../forms/Search";
import useCategory from "../../hooks/useCategory";
import { useCart } from "../../context/cart";

export default function Menu() {
  const [auth, setAuth] = useAuth();
  const { cart } = useCart();
  const categories = useCategory();
  const navigate = useNavigate();
  const collapseRef = useRef(null);
  const togglerRef = useRef(null);

  const closeNav = () => {
    const el = collapseRef.current;
    if (!el?.classList.contains("show")) return;
    const Collapse = window.bootstrap?.Collapse;
    if (Collapse) {
      Collapse.getOrCreateInstance(el).hide();
    } else {
      el.classList.remove("show");
      togglerRef.current?.setAttribute("aria-expanded", "false");
    }
  };

  const handleNavClick = () => {
    if (window.innerWidth < 992) closeNav();
  };

  useEffect(() => {
    const onOutsideClick = (e) => {
      const collapse = collapseRef.current;
      const toggler = togglerRef.current;
      if (!collapse?.classList.contains("show")) return;
      if (collapse.contains(e.target) || toggler?.contains(e.target)) return;
      closeNav();
    };

    document.addEventListener("mousedown", onOutsideClick);
    document.addEventListener("touchstart", onOutsideClick);
    return () => {
      document.removeEventListener("mousedown", onOutsideClick);
      document.removeEventListener("touchstart", onOutsideClick);
    };
  }, []);

  const logout = () => {
    setAuth({ ...auth, user: null, token: "" });
    localStorage.removeItem("auth");
    navigate("/login");
    handleNavClick();
  };

  const countCartItems =
    cart?.reduce((total, item) => total + 1, 0) || 0;

  return (
    <nav className="navbar custom-navbar navbar-expand-lg sticky-top">
      <div className="container-fluid px-4">
        <NavLink to="/" className="navbar-brand brand-logo" onClick={handleNavClick}>
          Bookrr
        </NavLink>

        <button
          ref={togglerRef}
          className="navbar-toggler bg-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbar" ref={collapseRef}>
          <ul className="navbar-nav me-auto gap-3">
            <li>
              <NavLink
                to="/"
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `custom-link ${isActive ? "active-link" : ""}`
                }
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/shop"
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `custom-link ${isActive ? "active-link" : ""}`
                }
              >
                Shop
              </NavLink>
            </li>

            <li className="dropdown">
              <span
                className="custom-link dropdown-toggle"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
              >
                Categories
              </span>

              <ul className="dropdown-menu dropdown-custom zx-dropdown-elite-77x">
                <li>
                  <NavLink className="dropdown-item fw-bold" to="/categories" onClick={handleNavClick}>
                    All Categories
                  </NavLink>
                </li>

                {categories.map((c) => (
                  <li key={c._id}>
                    <NavLink
                      className="dropdown-item"
                      to={`/products-by-category/${c.slug}`}
                      onClick={handleNavClick}
                    >
                      {c.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>

            <li>
              <NavLink
                to="/contact"
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `custom-link ${isActive ? "active-link" : ""}`
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>

          {/* RIGHT */}
          <div className="nav-actions-wrap">
            <div className="search-wrapper">
              <Search />
            </div>

            <div className="nav-actions-bottom">
              {!auth?.user ? (
                <div className="auth-buttons">
                  <NavLink to="/login" className="btn login-btn" onClick={handleNavClick}>
                    Login
                  </NavLink>
                  <NavLink to="/register" className="btn register-btn" onClick={handleNavClick}>
                    Register
                  </NavLink>
                </div>
              ) : (
                <div className="dropdown">
                  <span
                    className="user-profile dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <Avatar style={{ backgroundColor: "#0072ff" }}>
                      {auth?.user?.name?.charAt(0).toUpperCase()}
                    </Avatar>
                    <span className="user-name-text">{auth?.user?.name}</span>
                  </span>

                  <ul className="dropdown-menu dropdown-menu-end zx-user-dd-77x">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to={`/dashboard/${
                          auth?.user?.role === 1 ? "admin" : "user"
                        }`}
                        onClick={handleNavClick}
                      >
                        Dashboard
                      </NavLink>
                    </li>
                    <li>
                      <span
                        className="dropdown-item text-danger"
                        onClick={logout}
                      >
                        Logout
                      </span>
                    </li>
                  </ul>
                </div>
              )}

              <div
                className="cart-wrapper"
                onClick={() => {
                  navigate("/cart");
                  handleNavClick();
                }}
              >
                <Badge count={countCartItems} size="small" offset={[0, 6]}>
                  <FaShoppingCart className="cart-icon" />
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
